/**
 * 弹层内异步选择器滚动触底加载。
 * 首页等场景会在 popup 打开后才挂载选择器，且 wrap 高度在 nextTick 才算好，
 * 仅在 onMounted 绑一次容易丢监听；这里在布局稳定后多次绑定。
 */
export const useAsyncPickerWrapper = (
  asyncPickerWrap: Ref<HTMLElement | undefined | null>,
  loadMore: (this: HTMLElement, ev: Event) => any,
) => {
  let boundEl: HTMLElement | null = null

  const unbind = () => {
    if (!boundEl) return
    boundEl.removeEventListener('scroll', loadMore)
    boundEl = null
  }

  const bind = () => {
    const el = asyncPickerWrap.value
    if (!el) return
    if (boundEl === el) return
    unbind()
    el.addEventListener('scroll', loadMore, { passive: true })
    boundEl = el
  }

  const bindAfterLayout = () => {
    nextTick(() => {
      bind()
      requestAnimationFrame(() => {
        bind()
        // popup wrapHeight 常在打开后下一帧才写入
        setTimeout(bind, 50)
        setTimeout(bind, 200)
      })
    })
  }

  onMounted(bindAfterLayout)
  onActivated(bindAfterLayout)

  watch(asyncPickerWrap, () => {
    bindAfterLayout()
  })

  onUnmounted(() => {
    unbind()
  })
  onDeactivated(() => {
    unbind()
  })
}

/** 距底部阈值（px）内视为触底，避免亚像素导致永远不相等 */
export const isScrollReachBottom = (
  el: HTMLElement,
  threshold = 80,
): boolean => {
  const { scrollHeight, scrollTop, clientHeight } = el
  return scrollHeight - scrollTop - clientHeight <= threshold
}
